/**
 * Created by José Rafael Gutierrez on 23/07/2020.
 */
import filterGeneral from '@/store/modules/filters/general';

export default {
  filterGeneral,
};
